/** imported components
	
  * HeaderView ===> custom view component.
  * header.scss for ===> styling css file for this page.
  * useState ===> React hooks (useState is a way to get/set value)

**/
import React, { useState } from "react";
import "./header.scss";
import { HeaderView } from "./header-view";
//HeaderControler start
export const HeaderControler = (props) => {
	//Defining variables here
	const [dropdownIndex, setDropdownIndex] = useState(null);
	//Function to handle dropdown
	const HandleDropdown = (ddlIndex) => {
		if (ddlIndex === dropdownIndex) {
			setDropdownIndex(null);
		} else {
			setDropdownIndex(ddlIndex);
		}
	};
	//custom view component
	return <HeaderView dropdownIndex={dropdownIndex}  HandleDropdown={HandleDropdown} userShortname="SC" {...props} />;
};
